import { render, staticRenderFns } from "./UserSupport.vue?vue&type=template&id=438b2515&scoped=true&"
import script from "./UserSupport.vue?vue&type=script&lang=js&"
export * from "./UserSupport.vue?vue&type=script&lang=js&"
import style0 from "./UserSupport.vue?vue&type=style&index=0&id=438b2515&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438b2515",
  null
  
)

export default component.exports